import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ListItem } from '../../Generic/List';
import List from '../../Generic/List/List';
import Button from '../../Generic/Button/Button';
import styles from './DropDownPopUp-tw-styles';

export class DropDownPopUp extends Component {
  static propTypes = {
    showdropdownPopup: PropTypes.bool,
    locale: PropTypes.string,
    logout: PropTypes.func.isRequired,
  };

  static defaultProps = {
    showdropdownPopup: false,
    locale: 'pt-br',
  };

  logoutClick = () => {
    if (window.location.pathname === '/pt-br/editprofilepage')
      window.location.href = '/pt-br/loginpage';
    const { logout } = this.props;
    logout();
  };
  render() {
    const { showdropdownPopup, locale } = this.props;
    const i18nMessages = require(`../../../constants/messages/${locale}`);
    const profileLink = `/${locale}/editprofilepage`;
    return (
      <div className={showdropdownPopup ? '' : 'hidden'}>
        <List className={styles.dropdownlist}>
          <ListItem>
            <a href={profileLink}>{i18nMessages.myprofile}</a>
            <Button
              className="event_profile_logout"
              onClick={() => this.logoutClick()}
              data-action-detail="logout"
            >
              {i18nMessages.logout}
            </Button>
          </ListItem>
        </List>
      </div>
    );
  }
}
export default DropDownPopUp;
